import React, { useState, ComponentType, ReactElement } from 'react';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert, { AlertProps } from '@mui/material/Alert';
import Slide from '@mui/material/Slide';
import Grow from '@mui/material/Grow';
import { TransitionProps } from '@mui/material/transitions';
import Transitions from '../Shared/snackBarModels/Transitions';
import SnackBarDefinition from '../Shared/snackBarModels/SnackBarDefinition';
import { useSelector, useDispatch, shallowEqual } from 'react-redux';
import { AppDispatch, RootState } from '../../store/store';
import { setSnackBarOpen } from '../../store/reducers/snackbar/snackBarOpenSlice';

/**
 * Display actual message in snack bar.
 */
const Alert = React.forwardRef<HTMLDivElement, AlertProps>(
 function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
 },
);

/**
 * Component to display snack bar.
 * @param props
 * @returns
 * open: true | false
 * duration: miliseconds
 * vertical: top | bottom
 * horizontal: left | center | right
 * message: string
 * messageType: | success | warning | error
 * Transition Type: Slide | Grow
 */
const SnackBar = (props: SnackBarDefinition) => {
 const dispatch = useDispatch<AppDispatch>();

 // const [open, setOpen] = useState(props.open);
 // const [horizontal, setHorizontal] = useState(props.horizontal);
 const [horizontal] = useState(props.horizontal);
 // const [duration, setDuration] = useState(props.duration);
 // const [vertical, setVertical] = useState(props.vertical);
 const [vertical] = useState(props.vertical);
 //const [messasgeType, setMessasgeType] = useState(props.messageType);

 const snackBarOpen = useSelector(
  (state: RootState) => state.snackBarOpen,
  shallowEqual,
 );

 const snackBarMessage = useSelector(
  (state: RootState) => state.snackBarMessage,
  shallowEqual,
 );

 const snackBarMessageType = useSelector(
  (state: RootState) => state.snackBarMessageType,
  shallowEqual,
 );

 /**
  * Initial parameters and Transition.
  */
 const [transitionState] = useState<{
  open: boolean;
  transition: ComponentType<
   TransitionProps & {
    children: ReactElement<any, any>;
   }
  >;
 }>({
  open: false,
  transition: props.transition === Transitions.SLIDE ? Slide : Grow,
 });

 /**
  * Close snack Bar.
  * @param event
  * @param reason
  * @returns
  */
 //const handleClose = (event?: SyntheticEvent | Event, reason?: string) => {
 const handleClose = () => {
  dispatch(setSnackBarOpen(false));
 };

 return (
  <Snackbar
   open={snackBarOpen}
   autoHideDuration={2000}
   onClose={handleClose}
   anchorOrigin={{ vertical, horizontal }}
   TransitionComponent={transitionState.transition}
  >
   <Alert
    onClose={handleClose}
    severity={snackBarMessageType}
    sx={{
     width: '100%',
     fontWeight: 500,
     fontSize: '14px',
     borderRadius: '10px',
     boxShadow: '0 4px 12px rgba(0,0,0,0.1)',

     ...(snackBarMessageType === 'error' && {
      backgroundColor: '#ffebee',
      color: '#c62828',
     }),
     ...(snackBarMessageType === 'success' && {
      backgroundColor: '#e8f5e9',
      color: '#2e7d32',
     }),

     '& .MuiAlert-action': {
      alignItems: 'center',
      display: 'flex',
      marginRight: '4px',
     },

     '& .MuiSvgIcon-root': {
      fontSize: '20px',
      cursor: 'pointer',
      marginTop: '-2px',
      alignSelf: 'center',
     },
    }}
   >
    {snackBarMessage}
   </Alert>
  </Snackbar>
 );
};

export default SnackBar;
